<template>
  <div class="pwmat-trial-download-background">
    <div class="pwmat-trial-download-banner">
      <div class="pwmat-trial-download-container">
        <div class="pwmat-trial-download-banner-title">{{ $t("pwmatgpu.banner") }}</div>
      </div>

      <img class="pwmat-trial-download-banner-img" src="../../assets/about/banner.png">
    </div>
    <div class="pwmat-trial-download-container">

     <div class="pwmat-trial-download-content">
       <div class="pwmat-trial-download-content-title">
         <div class="pwmat-trial-download-content-title-text">{{ $t("pwmatdcu.title") }}</div>
         <div class="pwmat-trial-download-line"></div>
       </div>


       <div class="pwmat-trial-download-content-info">
         <p class="pwmat-trial-download-content-info-text" style="text-align: justify;font-size: 18px">{{ $t("pwmatdcu.describe") }}
         </p>
       </div>

       <div>
         <table class="pwmat-trial-download-introduce-table">
           <tr class="pwmat-trial-download-introduce-th">
             <th class="pwmat-trial-download-introduce-text-th">{{ $t("pwmatdcu.tableR0C1") }}</th>
             <th class="pwmat-trial-download-introduce-text-th">{{ $t("pwmatdcu.tableR0C2") }}</th>
             <th class="pwmat-trial-download-introduce-text-th">{{ $t("pwmatgpu.tableR0C3") }}</th>
             <th class="pwmat-trial-download-introduce-text-th">{{ $t("pwmatgpu.tableR0C4") }}</th>
             <th class="pwmat-trial-download-introduce-text-th">{{ $t("pwmatgpu.tableR0C5") }}</th>
           </tr>
           <tr class="pwmat-trial-download-introduce-td" v-for="version in DCUDownload" :key=version @click="showDCUDownloadModal(version.id)">
             <td class="pwmat-trial-download-introduce-text-td">{{version.CUDA}}</td>
             <td class="pwmat-trial-download-introduce-text-td">{{version.OpenMPI}}</td>
             <td class="pwmat-trial-download-introduce-text-td">{{version.PWmatVersion}}</td>
             <td class="pwmat-trial-download-introduce-text-td" style="color: rgba(73,145,201,1)">{{version.installPackage}}
               <!--<a :href="MSTATION_DOWNLOAD+version.downloadUrl">{{version.installPackage}}</a>-->
             </td>
             <td class="pwmat-trial-download-introduce-text-td">{{version.updateTime}}</td>
           </tr>
         </table>
       </div>


       <div class="pwmat-trial-download-content-info">
         <p class="pwmat-trial-download-content-info-text" style="font-size: 24px">{{ $t("pwmatgpu.note") }} 1：<a class="pwmat-trial-download-info-a" @click="toPWmatUpdateFuncDCU">{{ $t("pwmatgpu.note1") }}</a></p>
       </div>
       <div class="pwmat-trial-download-content-info">
         <p class="pwmat-trial-download-content-info-text" style="font-size: 24px">{{ $t("pwmatgpu.note") }} 2：<a class="pwmat-trial-download-info-a" @click="toPWmatLicenseFunc">{{ $t("pwmatgpu.note22") }}</a></p>
       </div>
       <div class="pwmat-trial-download-content-info">
         <p class="pwmat-trial-download-content-info-text" style="font-size: 24px">{{ $t("pwmatgpu.note") }} 3：<a class="pwmat-trial-download-info-a" target="_blank" href="http://download.lonxun.com/pwmat-release-version/dcu_version">{{ $t("pwmatgpu.note3") }}</a></p>
       </div>

     </div>
    </div>


    <div class="modal fade" id="DCUDownloadModal" tabindex="-1" role="dialog">
      <div class="modal-dialog mstation-download-modal">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" >下载</h5>
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
          </div>
          <div class="modal-body">
            <p>更新说明：{{DCU.instruction}}</p>
            <p>下载：<a :href="MSTATION_DOWNLOAD+DCU.downloadUrl">{{DCU.installPackage}}</a></p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default mstation-download-modal-button" data-dismiss="modal">取消</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {DCUDownload} from "../../helpers/softwareDownload_server"
  import {MSTATION_DOWNLOAD} from "../../helpers/consts"
  import $ from 'jquery'

  export default {
    name: "companyIntroduce",
    data(){
      return {
        DCUDownload,
        MSTATION_DOWNLOAD,
        DCU:''

      }
    },
    methods:{
      toPWmatUpdateFuncDCU(){
        this.$router.push({ name: 'PWmatUpdateFuncDCU'})
      },
      toPWmatLicenseFunc(){
        this.$router.push({ name: 'PWmatLicenseFunc'})
      },
      showDCUDownloadModal($id){
        this.DCU = DCUDownload[$id]
  //      console.log(this.MSTATION)
        $('#DCUDownloadModal').modal('show')
      }

    }
  }
</script>

<style scoped>
  .pwmat-trial-download-container {
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
  }
  .pwmat-trial-download-background{
    margin-top: 70px;
  }
  .pwmat-trial-download-banner{
    overflow:hidden;
  }
  .pwmat-trial-download-banner-title{
    font-size:24px;
    font-family:PingFangSC-Semibold,sans-serif;
    font-weight:600;
    color:rgba(255,255,255,1);
    line-height:50px;
    position: absolute;
    margin-top: 60px;
  }
  .pwmat-trial-download-banner-img{
    min-width:100%;
    height:165px;
  }
  .pwmat-trial-download-content{
    margin-top: 30px;
    margin-bottom: 90px;
  }
  .pwmat-trial-download-content-title{
    padding-top: 50px;
  }
  .pwmat-trial-download-content-title-text{
    font-size:30px;
    font-family:PingFangSC-Medium,sans-serif;
    font-weight:500;
    color:rgba(73,145,201,1);
    line-height:50px;
  }
  .pwmat-trial-download-content-note-text{
    font-size:16px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(79,76,77,1);
    line-height:25px;
    margin-bottom: 0px;
  }
  .pwmat-trial-download-content-info{
    margin-top: 40px;
  }
  .pwmat-trial-download-content-info-text{
    font-size:16px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(79,76,77,1);
    line-height:25px;
  }
  .pwmat-trial-download-line{
    height:1px;
    background:rgba(240,240,240,1);
    margin-top: 8px;
  }

  .pwmat-trial-download-introduce-table{
    width: 100%;
    border:1px solid rgba(240,240,240,1);
  }
  .pwmat-trial-download-introduce-th{
    background:rgba(73,145,201,1);
    height: 45px;
  }
  .pwmat-trial-download-introduce-td{
    height: 45px;
    cursor: pointer;
  }
  .pwmat-trial-download-introduce-td:hover{
    background:rgba(73,145,201,0.1);
  }
  .pwmat-trial-download-introduce-text-th{
    border:1px solid rgba(240,240,240,1);
    font-size:16px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(255,255,255,1);
    line-height:25px;
    padding-left: 16px;
  }
  .pwmat-trial-download-introduce-text-td{
    border:1px solid rgba(240,240,240,1);
    font-size:16px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    line-height:25px;
    padding: 16px;
  }
  .pwmat-trial-download-info-a{
    cursor: pointer;
  }
  .pwmat-trial-download-info-a:hover,
  .pwmat-trial-download-info-a:active{
    text-decoration:underline;
  }
  .mstation-download-modal{
    margin-top: 10%
  }
  .mstation-download-modal-button:hover,
  .mstation-download-modal-button:active,
  .mstation-download-modal-button:focus{
    box-shadow:none !important;
    outline: none !important;
  }

  @media screen and (max-width:482px) {
    .pwmat-trial-download-container{
      max-width: 100%;
    }
  }
  @media screen and (min-width:482px) and (max-width:768px) {
    .pwmat-trial-download-container{
      max-width: 450px;
    }
  }
  @media screen and (min-width:768px) and (max-width:1100px) {
    .pwmat-trial-download-container{
      max-width: 736px;
    }
  }
  @media screen and (min-width:1100px) and (max-width:1444px) {
    .pwmat-trial-download-container{
      max-width: 1068px;
    }
  }
  @media screen and (min-width:1444px) {
    .pwmat-trial-download-container{
      max-width: 1068px;
    }
  }

</style>
